import React, {FunctionComponent} from 'react';
import {Box} from '@mui/material';

interface HighlightTextProps {
    text: string;
    query: string;
}

/** Highlights query token matches inside titles and subtitles. */
const HighlightText: FunctionComponent<HighlightTextProps> = ({text, query}) => {
    const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (!tokens.length) {
        return <>{text}</>;
    }

    const pattern = new RegExp(`(${tokens.map((token) => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
    const parts = text.split(pattern);

    return (
        <>
            {parts.map((part, index) => {
                const matched = tokens.some((token) => part.toLowerCase() === token);
                if (!matched) {
                    return <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>;
                }
                return (
                    <Box
                        key={`${part}-${index}`}
                        component="span"
                        sx={{
                            color: 'primary.main',
                            fontWeight: 700,
                            bgcolor: (theme) => theme.palette.mode === 'dark'
                                ? 'rgba(144, 202, 249, 0.16)'
                                : 'rgba(25, 118, 210, 0.12)',
                            borderRadius: 0.5,
                            px: 0.25,
                        }}
                    >
                        {part}
                    </Box>
                );
            })}
        </>
    );
};

export default HighlightText;
